import { PROPOSAL_ACCENT, PROPOSAL_COPY_FONT } from "@/lib/proposalTheme";

type Props = {
  paragraph: string;
  label?: string;
};

export default function ProposalIntroSection({
  paragraph,
  label = "Tailored to you",
}: Props) {
  return (
    <section
      className="rounded-xl border border-[#1A2744]/12 bg-white/70 px-5 py-4 shadow-sm"
      style={{ fontFamily: PROPOSAL_COPY_FONT }}
    >
      <p className="mb-2 text-[10px] font-semibold uppercase tracking-[0.2em]" style={{ color: PROPOSAL_ACCENT }}>
        {label}
      </p>
      <p className="whitespace-pre-wrap text-sm leading-relaxed text-[#1A2744]/90">{paragraph}</p>
    </section>
  );
}
